<template>
  <v-container fluid grid-list-md class="grey lighten-5 ma-2" >
    <v-row>
      <v-flex xs12 sm12 md8 lg8 ex8>
        <v-card ref="form">
          <v-card-text>
              <v-row no-gutters>
                <v-flex xs="12" class="py-0 px-2">                
                    <h2>Usklada knjiga i inf.posrednika</h2>
                </v-flex>
              </v-row>

              <v-row no-gutters>
                <v-col xs="4" class="py-0 px-2">
                    {{lang.CompanyName}}
                </v-col>
                <v-col xs="4" class="py-0 px-2">
                    <span style="font-weight:bold">{{mainledgerAna.CompanyNameDatabase}}</span>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col xs="4" class="py-0 px-2">
                    {{lang.BusinessYear}}
                </v-col>
                <v-col xs="4" class="py-0 px-2">
                    <span style="font-weight:bold">{{mainledgerAna.BusinessYear}}</span>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col xs="4" class="py-0 px-2">
                  {{lang.User}}
                </v-col>
                <v-col xs="8" class="py-0 px-2">
                    <span style="font-weight:bold">{{mainledgerAna.First}} {{mainledgerAna.Last}}, {{mainledgerAna.email}}, {{mainledgerAna.UserId}}</span>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <br>

          <v-row>
            <v-col xs="2" >
                Max.period 1 mjesec
            </v-col>
              <v-col xs="2" >
                <v-dialog
                  ref="dialog1"
                  persistent
                  v-model="modal1"
                  width="290px"
                  :return-value.sync="startDate"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="formatDate1"
                      :label="langC.FromDate"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
          
                    ></v-text-field>
                  </template>

                  <v-date-picker v-model="startDate" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="modal1 = false">Cancel</v-btn>
                    <v-btn color="primary" @click="$refs.dialog1.save(startDate)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>

              <v-col xs="2" >
                <v-dialog
                  ref="dialog2"
                  persistent
                  v-model="modal2"
                  width="290px"
                  :return-value.sync="endDate"
                >
                 <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="formatDate2"
                      :label="langC.ToDate"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
 
                  <v-date-picker v-model="endDate" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="modal2 = false">Cancel</v-btn>
                    <v-btn color="primary" @click="$refs.dialog2.save(endDate)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>

               <v-col cols="12" sm="2" md="2" xs="2" lg="2" xl="2"  >
                  <v-select
                  v-model="selectedMonth"
                  :items="months"
                  label="Mjesec"
                  clearable
                ></v-select>
              </v-col>
              <v-col xs="2" >
                <v-btn
                    color="blue"
                    :disabled="!formIsValid"
                    @click="loadEinvoices()">
                    {{lang.LoadFromInt}}
                </v-btn>
              </v-col>
          </v-row>           

          
          </v-card-text>
          <v-divider class="mt-1 mb-3"></v-divider>
          <v-card-actions>


          </v-card-actions>
        </v-card>
      </v-flex>

    </v-row>

    <v-progress-linear v-if="saving"
      indeterminate
      color="blue"
      class="mt-5"
    ></v-progress-linear>

    <v-row v-if="showCard1">
      <MainLedgerBooksList :items="items" :total="total" @myEvent="myMethod" @myEvent2="myMethod2"/>
    </v-row>

    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      bottom
      :color="color"
      >
      {{ text }}
    </v-snackbar>
  </v-container>
</template>

<script>

import dayjs from 'dayjs'
import MainLedgerService from '@/services/MainLedgerService'
import MainLedgerDetailService from '@/services/MainLedgerDetailService'
import MainLedgerBooksList from './MainLedgerBooksList'
import PondiService from '@/services/PondiService'
import DocumentService from '@/services/DocumentService'
import DocumentDetailService from '@/services/DocumentDetailService'
import ledgerEN from './MainLedgerDescEN'
import ledgerHR from './MainLedgerDescHR'
import commEn from "@/language/commonEN"
import commHr from "@/language/commonHR"
import dateFormat from '@/snippets/dateFormat'
import { defMainLedger, defNew, defMainQuery,defNewpartner, defMainLedgerDetail, defMainLedgerDetailFill } from './mainledgerHelper'
import { round, parseNum, dynamicSort, doZeros } from '@/snippets/allSnippets'
import { testLastUpdate, newUpdates } from '@/services/TestLastUpdate'
import {defBankOrder, defNewBankOrder} from '../Salarie/salarieHelper'
import PartnerService from '@/services/PartnerService'
import { defDocument,defDocumentDetail,defNewDocumentDetail} from '@/components/Document/documentHelper'

export default {
  name: 'mainledgerbooks',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      snackbar: false,
      text: '',
      timeout: 2000,
      color: 'green',
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      dateFormatted: null,
      dateFormatted2: null,
      modal: false,
      modal1: false,
      modal2: false,
      modal3: false,
      modal4: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      date1: null,
      date2: null,
      msg: '',
      valid: true,
      startDate: null,
      endDate: null,
      mainledgerAna: {
        CompanyId: 0,
        CompanyNameDatabase: '',
        BusinessYear: 0,
        UserId: 0,
        email: '',
        First: '',
        Last: '',
        fromDate: null,
        toDate: null,
        fromAccount: '',
        toAccount: ''
      },
      comp: {},
      error: null,
      localError: false,
      size: 'sm',
      account4Loc: [],
      account4LocFrom: [],
      account4LocTo: [],
      partners: [],
      items: [],
      items4: [],
      items6: [],
      items9: [],
      psItems: [],
      CompanyId: 0,
      selectPa: {},
      selectA4: {},
      selectA4from: {},
      selectA4to: {},
      selectUs3: {},
      mainQuery: {},
      havePath: '',
      PrintDate: null,
      lang: {},
      langC: {},
      saving: false,
      showCard1: false,
      showCard2: false,
      showCard3: false,
      showCard4: false,
      showCard5: false,
      showCard6: false,
      showCard9: false,
      showCard10: false,
      bookType: [],
      bookTypeSelected: {
      },
      bookTypeSelectedName: 'TEM',
      sameAsFrom: false,
      total: 0,
      fTotal2: 0,
      fTotal3: 0,
      fTotal4: 0,
      fTotal5: 0,
      ffTotal1: 0,
      ffTotal2: 0,
      ffTotal3: 0,
      ffTotal4: 0,
      ffTotal5: 0,
      projectTypes: [],
      selectPT: {},
      newItem: {},
      newItems: [],
      exRate: this.$store.getters.NeedDefExRate,
      exRate2: 1,
      totalsNine: {},
      finishYear: false,
      finishYearDesc: '',
      months: [1,2,3,4,5,6,7,8,9,10,11,12],
      selectedMonth: null,
      showEUR: true,
      displayEURselector: false,
      pItems: [],
      allItems: [],
      fullAdmin: false,
      bookItems: [],
      locBookID: null,
      doc: {},
      mainledger: {},
      document: {},
      documentDet: {},
      activItems: [],
      partId: null
    }
  },
  components: {
    MainLedgerBooksList
  },
  async mounted () {
    if (this.$store.state.language === "EN") {
      this.lang = ledgerEN
      this.langC = commEn;
    }
    if (this.$store.state.language === "HR") {
      this.lang = ledgerHR
      this.langC = commHr;
    }

    this.$store.dispatch('setTikTok', 0)
   
    // need five arrays with partners, employes, tasktype, taskdepartment, users
    if (this.$store.state.companyid) {
      this.CompanyId = this.$store.state.companyid
      this.mainledgerAna.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
    }

    this.showEUR = this.$store.state.businessYear && this.$store.state.businessYear <= 2022 ? true : false
    
    this.comp = this.$store.state.companyActiv
    if (this.CompanyId > 0) {
      //await checkPartners(0)
      await testLastUpdate()
      if (this.$store.state.partnerStore) {
        this.partners = this.$store.state.partnerStore
      }
    }
    if (this.$store.state.user.id) {
      this.mainledgerAna.UserId = this.$store.state.user.id
    }
    if (this.$store.state.user.email) {
      this.mainledgerAna.email = this.$store.state.user.email
    }
    if (this.$store.state.user.First) {
      this.mainledgerAna.First = this.$store.state.user.First
    }
    if (this.$store.state.user.Last) {
      this.mainledgerAna.Last = this.$store.state.user.Last
    }
    this.mainledgerAna.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 1
    this.mainledgerAna.CompanyNameDatabase = this.$store.state.companyName ? this.$store.state.companyName : null
    this.mainledgerAna.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2022
    this.displayEURselector = this.$store.state.businessYear <= 2022 ? true : false
    this.finishYearDesc = this.lang.FinishYear + this.mainledgerAna.BusinessYear

    let locDate1 = new Date()
    this.PrintDate = dayjs().format('DD.MM.YYYY, H:mm')
    
    this.startDate = dayjs([this.mainledgerAna.BusinessYear]).startOf('month').format('YYYY-MM-DD')
    this.endDate = dayjs([this.mainledgerAna.BusinessYear]).endOf('month').format('YYYY-MM-DD')
    locDate1.getDate()
    locDate1.getMonth() + 1
    locDate1.getFullYear()

  },
  computed: {
    formIsValid () {
      return this.startDate !== null &&
        this.endDate !== null &&
        this.mainledgerAna.CompanyId !== ''
    },
    formatDate1() {
      return this.startDate
        ? dateFormat(this.startDate)
        : "";
    },
    formatDate2() {
      return this.endDate
        ? dateFormat(this.endDate)
        : "";
    },
  },
  methods: {
    getRndInteger(min, max) {
      return Math.floor(Math.random() * (max - min) ) + min;
    },
    // create receipt purchase from xml

    async myMethod2(param) {
      try {
        this.saving = true
        console.log('param', param)
        for (var member in this.doc) delete this.doc[member];
        this.locBookID = param

        const query = {
          id: param,
          pondiKey: this.$store.state.companyActiv.eRacunProviderAPIkey ? this.$store.state.companyActiv.eRacunProviderAPIkey : '',
          companyId:  this.$store.state.companyid ? this.$store.state.companyid : 1,
          businessYear: this.$store.state.businessYear ? this.$store.state.businessYear : 2026,
          newId: this.getRndInteger(1000000000, 9000000000),
          notSaveDoc: true
        }
        const res = await PondiService.getxml(query)
        console.log('res', res)
        this.doc = res && res.data && res.data.invoice ? res.data.invoice : null
        if (Object.keys(this.doc).length > 0) {
          console.log('this.doc', this.doc)
          // create new Document
          await this.newGoods()
          // update items with connected document

          // const nema = false
          // if (this.items && this.items.length > 0) {
          //     this.items = this.items.map(item => {
          //       if (item.id === param) {
          //         return { ...item, 
          //           inBooks: true,
          //           BookID: this.mainledger.BookID,
          //           BookName: this.mainledger.BookName,
          //           BookingDate: this.mainledger.BookingDate,
          //           email: this.mainledger.email
          //          };
          //       }
          //       return item;
          //     });
          // }
          const newTikTok = this.$store.state.tikTok + 1
          this.$store.dispatch('setTikTok', newTikTok)
        }
        if (Object.keys(this.doc).length === 0){
          alert('Error! Something is wrong with load data!')
        }
        this.saving = false
      } catch (error) {
        this.saving = false
        console.log('error', error)
        alert(error)
      }
    },
    newGoodsDetails() {
        this.activItems.length = 0
        if (this.doc && this.doc.stavke && this.doc.stavke.length > 0) {
          console.log('this.doc.stavke: ', this.doc.stavke);
          this.doc.stavke.map(st => {
            this.documentDet = defDocumentDetail()
            this.documentDet = {...this.documentDet, ...defNewDocumentDetail()}
            const newId = this.getRndInteger(1000000000, 9000000000)

            const cijena = parseNum(st.cijena)
            const kolicina = parseNum(st.kolicina)
            const netoIznos = parseNum(st.netoIznos)
            const poreznaStopa = parseNum(st.poreznaStopa)

            this.documentDet.itemName = st.opis ? st.opis : ''
            this.documentDet.ItemSuppCode = st?.sifraDob ?? ''
            this.documentDet.ItemEANCode =st?.barcode ?? ''
            this.documentDet.itemPcsPlus = kolicina
            this.documentDet.itemSuppBasePrice = cijena
            this.documentDet.itemSuppDiscount = 0
            this.documentDet.itemSuppBasePriceAmount  = netoIznos
            this.documentDet.itemSuppPriceAmount = netoIznos
            this.documentDet.itemSuppDiscountAmount = 0
            this.documentDet.itemSuppPrice = cijena
            this.documentDet.itemVAT1Percetage = poreznaStopa
            this.documentDet.itemBaseAmount = netoIznos
            this.documentDet.itemBaseForeAmount = netoIznos
            this.documentDet.itemBaseAmountNoVAT = netoIznos
            this.documentDet.itemBaseForeAmountNoVAT = netoIznos
            const total = round((netoIznos * (1 + (poreznaStopa /100))),2)
            this.documentDet.itemBaseAmountWithVAT = total
            this.documentDet.itemBaseForeAmountWithVAT = total
            this.documentDet.itemAmountWithVAT = total
            this.documentDet.itemFullTotal = total
            this.documentDet.itemVAT1Amount = round((total - netoIznos),2)

            this.activItems.push(this.documentDet)
          })
          
          // cijena"3.95"
          // kolicina"5.000"
          // netoIznos"19.75"
          // opis"PAPIR FORoffice A4 80gr. 500/1"
          // poreznaOznaka"S"
          // poreznaStopa"25"
        }
    },
    async newGoods() {
      try {
      this.document = defDocument()
      this.docName === 'ReceiptPurchase'
      if (this.$store.state.companyid) {
        this.CompanyId = await this.$store.state.companyid
        this.mainQuery.CompanyId = await this.$store.state.companyid
      }
      this.mainQuery.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2026
      this.mainQuery.documentName = this.$store.state.documentActiv ? this.$store.state.documentActiv : ''
      this.document.documentSide = this.$store.state.documentSide ? this.$store.state.documentSide : 0

      this.document.UserId = this.$store.state.user.id ? this.$store.state.user.id : ''
      this.document.email = this.$store.state.user.email ? this.$store.state.user.email : 'test@cegrupa.com'
      this.document.First = this.$store.state.user.First ? this.$store.state.user.First : 'NoFirst'
      this.document.Last = this.$store.state.user.Last ? this.$store.state.user.Last : 'NoLast'
      this.document.uservatID = this.$store.state.user.vatID ? this.$store.state.user.vatID : '12345678901'
      this.document.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
      this.mainQuery.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
      this.document.CompanyNameDatabase = this.$store.state.companyName ? this.$store.state.companyName : ''
      this.document.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2024
      this.mainQuery.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2024
   
      this.mainQuery.documentName = 'ReceiptPurchase'
      this.document.documentName = 'ReceiptPurchase'
      this.document.documentAnalysis = 2
      this.document.documentSide = 1 
      let locDate1 = new Date()
      locDate1.getDate()
      locDate1.getMonth() + 1
      locDate1.getFullYear()
      const nrOfDays = this.$store.state.companyActiv.CompanyInvoiceDefDays ? parseInt(this.$store.state.companyActiv.CompanyInvoiceDefDays) : 15
      this.document.documentDate = dayjs(new Date()).format('YYYY-MM-DD')
      this.document.documentTime = dayjs(new Date()).format('HH:mm')
      this.document.documentInvoiceStartDate = dayjs(new Date()).format('YYYY-MM-DD')
      this.document.documentInvoiceEndDate = dayjs(new Date()).add(nrOfDays, 'days').format('YYYY-MM-DD')
      this.document.documentInvoiceEndPeriodDate = dayjs(new Date()).format('YYYY-MM-DD')
      this.document.documentHomeCurrency = this.$store.state.businessYear <= 2022 ? 'Kn' : 'EUR'
      this.document.documentForeignCurrency = 'EUR'
      this.document.documentExRate = this.$store.state.businessYear <= 2022 ? 7.5345 : 1
      const part = this.doc.prodavatelj
      console.log('1 -->> part ', part)
      this.document.partnerName = part.naziv
      this.document.partnerVATID = part.oib
      this.document.partnerCity = part.adresa.grad
      this.document.partnerStreet = part.adresa.ulica
      this.document.partnerPostcode = part.adresa.postanskiBroj
      this.document.partneremail = part.kontakt && part.kontakt.email ? part.kontakt.email : ''

      const partNew = {}
      partNew.partnerName  = this.document.partnerName 
      partNew.partnerVATID  = this.document.partnerVATID
      partNew.partnerCity  = this.document.partnerCity
      partNew.partnerStreet  = this.document.partnerStreet 
      partNew.partnerPostcode  = this.document.partnerPostcode 
      partNew.partneremail  = this.document.partneremail 

      const haveIt = await this.findByVATID(partNew)
      if (!haveIt) {
        console.log('Nemam partnera dodajem NOVOG Partnera document')
        // add new partner
        await this.addeditPartner(partNew)
        this.document.partnerId = this.partId
      }

      const lastNr = {}
      const side = 1
      lastNr.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
      lastNr.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2024
      if (side === 1 || side === 2) {
        lastNr.WareHouseId = this.$store.state.warehousemarkid ? this.$store.state.warehousemarkid : 1
      }
      lastNr.documentName = 'ReceiptPurchase'

      this.document.CompanyNameDatabase = this.$store.state.companyName ? this.$store.state.companyName : ''
      this.document.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2024
      
      this.document.documentId = parseInt((await DocumentService.choose(lastNr)).data.docNumber)
      console.log('this.document.documentId ', this.document.documentId)
      this.newGoodsDetails()

      if (this.document.documentId && this.document.documentId > 0)
        {
          this.document.documentIdGeneral = this.$store.state.companyName + '-' + this.$store.state.businessYear + '-' + this.$store.state.documentActiv + '-' + this.document.documentId + '-' + (this.$store.state.warehousemarkid ? this.$store.state.warehousemarkid : 1)
          this.document.WareHouseId = (this.$store.state.warehousemarkid ? this.$store.state.warehousemarkid : 1)
          const whObj =  this.$store.state.warehouseState ? this.$store.state.warehouseState.find(whID => whID.WareHouseId === this.$store.state.warehousemarkid) : []
          this.document.WareHouseName = whObj && whObj.WareHouseName ? whObj.WareHouseName : ''
          console.log('postam this.document: ', this.document);
          await DocumentService.post(this.document)
            .then(async(response) => {
              const newDoc = response.data && response.data.newDoc ? response.data.newDoc : null
              if (newDoc && newDoc.id) {
                console.log('newDoc: ', newDoc);
                
                for (let i = 0; i < this.activItems.length; i++) {
                  Object.assign(this.activItems[i],
                   { 
                      databaseDocID: newDoc.id,
                      CompanyId: this.document.CompanyId,
                      CompanyNameDatabase: this.document.CompanyNameDatabase,
                      BusinessYear: this.document.BusinessYear,
                      UserId: this.document.UserId,
                      email: this.document.email,
                      documentName: 'ReceiptPurchase',
                      documentId: this.document.documentId,
                      documentIdGeneral: this.document.documentIdGeneral,
                      documentDate: this.document.documentDate,
                      partnerId: this.document.partnerId,
                      partnerNameDatabase: this.document.partnerNameDatabase,
                      HomeCurrency: 'EUR',
                      ForeignCurrency: 'EUR',
                      ExRate: 1,
                      ItemHomeCurrency: 'EUR',
                      ItemForeignCurrency: 'EUR',
                      ItemExRate: 1
                  });
                }
                

                await DocumentDetailService.saveitems(this.activItems).then(res => {
                  this.text = this.langC.DocumentSaved + (res && res.data && res.data.message ? res.data.message : '')
                  this.color = 'green'
                  this.snackbar = true
                }).catch(err => {
                  console.log(err)
                  this.text = 'Error post!' + err
                  this.color = 'red'
                  this.snackbar = true
                  this.timeout = 4000
                })

              }
            })
            .catch(err => {
              // eslint-disable-next-line
              console.log(err)
              this.text = 'Error post!' + err
              this.color = 'red'
              this.snackbar = true
              this.timeout = 4000
            })
        }

      } catch (error) {
       alert('Greska! Error. ' + error) 
      }
    },
    async myMethod(param) {
      try {
        this.saving = true
        console.log('param', param)
        for (var member in this.doc) delete this.doc[member];
        this.locBookID = param

        const query = {
          id: param,
          pondiKey: this.$store.state.companyActiv.eRacunProviderAPIkey ? this.$store.state.companyActiv.eRacunProviderAPIkey : '',
          companyId:  this.$store.state.companyid ? this.$store.state.companyid : 1,
          businessYear: this.$store.state.businessYear ? this.$store.state.businessYear : 2026,
          newId: this.getRndInteger(1000000000, 9000000000),
          notSaveDoc: false
        }
        const res = await PondiService.getxml(query)
        console.log('res', res)
        this.doc = res && res.data && res.data.invoice ? res.data.invoice : null
        if (Object.keys(this.doc).length > 0) {
          console.log('this.doc', this.doc)
          // create new Mainledger Head
          await this.newdocument()
          // // fill it with data 
          this.mainledger.filexml_originalname = this.doc.filexml_originalname
          this.mainledger.filexml_destination = this.doc.filexml_destination
          this.mainledger.filexml_fieldname = ''
          this.mainledger.filexml_filename = this.doc.filexml_filename
          this.mainledger.filexml_mimetype = this.doc.filexml_mimetype
          this.mainledger.filexml_path = this.doc.filexml_path
          this.mainledger.filexml_size = 0
          this.mainledger.filepdf_originalname = this.doc.filepdf_originalname
          this.mainledger.filepdf_destination = this.doc.filepdf_destination
          this.mainledger.filepdf_fieldname = this.doc.filepdf_fieldname
          this.mainledger.filepdf_filename = this.doc.filepdf_filename
          this.mainledger.filepdf_mimetype = this.doc.filepdf_mimetype
          this.mainledger.filepdf_path = this.doc.filepdf_path
          this.mainledger.filepdf_size = 0
          this.mainledger.MLFree2 = this.doc.filepdf_originalname ? this.doc.filepdf_originalname : ''
          this.mainledger.MLFree3 = this.doc.filepdf_filename ? this.doc.filepdf_filename : ''
          this.mainledger.MLFree4 = this.doc.filepdf_destination ? this.doc.filepdf_destination : ''
          this.mainledger.MLFree5 = this.doc.filepdf_path ? this.doc.filepdf_path : ''
          await this.fillNewDocument()
          // update items with connected mainledger
          const nema = false
          if (this.items && this.items.length > 0) {
              this.items = this.items.map(item => {
                if (item.id === param) {
                  return { ...item, 
                    inBooks: true,
                    BookID: this.mainledger.BookID,
                    BookName: this.mainledger.BookName,
                    BookingDate: this.mainledger.BookingDate,
                    email: this.mainledger.email
                   };
                }
                return item;
              });
          }
          const newTikTok = this.$store.state.tikTok + 1
          this.$store.dispatch('setTikTok', newTikTok)
        }
        if (Object.keys(this.doc).length === 0){
          alert('Error! Something is wrong with load data!')
        }
        this.saving = false
      } catch (error) {
        this.saving = false
        console.log('error', error)
        alert(error)
      }

    },
    async newdocument () {
      try {
        if (this.$store.state.bookTypeSelected) {

          this.mainledger = defMainLedger()
          this.mainledger = {...this.mainledger, ...defNew()}
          this.mainQuery = {...defMainQuery()}

          this.mainledger.BookID = parseInt((await MainLedgerService.choose(this.mainQuery)).data.docNumber)
          this.mainledger.documentIdGeneral = this.$store.state.companyName + '-' + this.$store.state.businessYear + '-' + this.$store.state.documentActiv + '-' + this.mainledger.BookID 

          await this.$store.dispatch('setMainLedgerActiv', {})
          console.log('this.$store.state.bookTypeSelected', this.$store.state.bookTypeSelected)

          if (this.$store.state.bookTypeSelected && this.$store.state.bookTypeSelected.value) {
            this.mainledger.BookTypeID = parseInt(this.$store.state.bookTypeSelected.value)
            this.mainledger.BookName = this.$store.state.bookTypeSelected.text

            if (this.mainledger.BookID === 0) {
              this.mainledger.BookID = (await MainLedgerService.choose(this.mainQuery)).data.docNumber
            }

            this.mainledger.documentIdGeneral = this.$store.state.companyName + '-' + this.$store.state.businessYear + '-' + this.$store.state.documentActiv + '-' + this.mainledger.BookID 

            await MainLedgerService.post(this.mainledger)
            .then(res => {
              this.savedML = res.data.mainledger ? res.data.mainledger : {}
              this.mainledger = res.data.mainledger ? {...res.data.mainledger} : {}
              this.$store.dispatch('setMainLedgerid', this.savedML.id)
              this.$store.dispatch('setMainLedgerActiv', this.savedML ? this.savedML : {})
              this.locBookID = parseInt(this.savedML.BookID)
            })
            .catch(err => {
              this.error = err.data
              this.text = 'Error1! Cannot save document to database. ' + err
              this.color = 'red'
              this.snackbar = true
            })
          } else {
            this.text = 'Greska! Nije odabrana vrsta knjige!!'
            this.color = 'red'
            this.snackbar = true
          }
          
        } else {
          this.text = this.lang.BookTypeNotSelected
          this.color = 'red'
          this.snackbar = true
        }
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async fillNewDocument() {
      this.mainledger.InvoiceNumber = this.doc.broj
      this.mainledger.InvoiceDate = this.doc.datum
      this.mainledger.InvoicePaymentDeadlineDate = null
      this.mainledger.BookingDate = this.doc.datumZaPDV
      this.mainledger.InvoicePaymentDeadlineDate = this.doc.rokplacanja
      console.log('0 --> this.$store.state.documentSide: ', this.$store.state.documentSide);
      let part = null
      if (this.$store.state.documentSide === 1) {
        part = this.doc.prodavatelj
      }
      if (this.$store.state.documentSide === 2) {
        part = this.doc.kupac
      }
      console.log('1 -->> part ', part)
      this.mainledger.partnerName = part.naziv
      this.mainledger.partnerVATID = part.oib
      this.mainledger.partnerCity = part.adresa.grad
      this.mainledger.partnerStreet = part.adresa.ulica
      this.mainledger.partnerPostcode = part.adresa.postanskiBroj
      this.mainledger.partneremail = part.kontakt && part.kontakt.email ? part.kontakt.email : ''

      const partNew = {}
      partNew.partnerName  = this.mainledger.partnerName 
      partNew.partnerVATID  = this.mainledger.partnerVATID
      partNew.partnerCity  = this.mainledger.partnerCity
      partNew.partnerStreet  = this.mainledger.partnerStreet 
      partNew.partnerPostcode  = this.mainledger.partnerPostcode 
      partNew.partneremail  = this.mainledger.partneremail

      const haveIt = await this.findByVATID(partNew)
      if (!haveIt) {
        console.log('Nemam partnera dodajem NOVOG Partnera')
        // add new partner
        await this.addeditPartner(partNew)
        this.mainledger.partnerId = this.partId
      }

      // ----------------------------------------------------- Novci
      this.mainledger.InvoiceAmount = this.doc.ukupno.zaUplatu
      this.mainledger.InvoiceForeginAmount = this.doc.ukupno.zaUplatu
      
      // ---- virman  
      const InstructionNote = this.doc.placanje.opisPlacanja ? this.doc.placanje.opisPlacanja : '' // opis placanja
      const PaymentID = this.doc.placanje.pozivNaBroj  // poziv na broj HR00 123456
      this.mainledger.partnerBankIBAN = this.doc.placanje.iban

       if (this.$store.state.companyActiv.notinVAT=== false) { 
          if (Array.isArray(this.doc.poreziDetaljno)){
            // ima vise poreznih stopa
            this.doc.poreziDetaljno.map(tax => {
              const taxVATPer = parseNum(tax.postotak,2)
              const TaxAmount = parseNum(tax.iznosPoreza,2)
              const TaxableAmount = parseNum(tax.osnovica,2)

              if (taxVATPer === 25) {
                this.mainledger.VAT1Amount = round(TaxAmount,2)
                this.mainledger.VAT1PerCanUse = 100
                this.mainledger.VAT1CanUse = round(TaxAmount,2)
                this.mainledger.VAT1CanTUse = 0
                this.mainledger.VAT1Base = round(TaxableAmount ,2)
              }
              if (taxVATPer === 13) {
                this.mainledger.VAT2Amount = round(TaxAmount,2)
                this.mainledger.VAT2PerCanUse = 100
                this.mainledger.VAT2CanUse = round(TaxAmount,2)
                this.mainledger.VAT2CanTUse = 0
                this.mainledger.VAT2Base = round(TaxableAmount ,2)
              }
              if (taxVATPer === 5) {
                this.mainledger.VAT3Amount = round(TaxAmount,2)
                this.mainledger.VAT3PerCanUse = 100
                this.mainledger.VAT3CanUse = round(TaxAmount,2)
                this.mainledger.VAT3CanTUse = 0
                this.mainledger.VAT3Base = round(TaxableAmount ,2)
              }
              if (taxVATPer === 0) {
                this.mainledger.VAT4Base = round(TaxableAmount,2)
              }
            })
          }
          // if (!Array.isArray(taxSubtotal)){
          //   // ima jednu poreznu stopu
          //   const taxCategory = taxSubtotal['cac:TaxCategory']
          //   const taxVATPer = taxCategory['cbc:Percent']
          //   const TaxAmount = taxSubtotal['cbc:TaxAmount']
          //   const TaxableAmount = taxSubtotal['cbc:TaxableAmount']
          //   if (taxVATPer === 25) {
          //     this.mainledger.VAT1Amount = round(TaxAmount,2)
          //     this.mainledger.VAT1PerCanUse = 100
          //     this.mainledger.VAT1CanUse = round(TaxAmount,2)
          //     this.mainledger.VAT1CanTUse = 0
          //     this.mainledger.VAT1Base = round(TaxableAmount ,2)
          //   }
          //   if (taxVATPer === 13) {
          //     this.mainledger.VAT2Amount = round(TaxAmount,2)
          //     this.mainledger.VAT2PerCanUse = 100
          //     this.mainledger.VAT2CanUse = round(TaxAmount,2)
          //     this.mainledger.VAT2CanTUse = 0
          //     this.mainledger.VAT2Base = round(TaxableAmount ,2)
          //   }
          //   if (taxVATPer === 5) {
          //     this.mainledger.VAT3Amount = round(TaxAmount,2)
          //     this.mainledger.VAT3PerCanUse = 100
          //     this.mainledger.VAT3CanUse = round(TaxAmount,2)
          //     this.mainledger.VAT3CanTUse = 0
          //     this.mainledger.VAT3Base = round(TaxableAmount ,2)
          //   }
          // }
        }
        console.log('this.mainledger PUT ', this.mainledger)
        await this.calculateVATAmount()
        await this.updateMl()
    },
    async updateMl() {
      try {
        await MainLedgerService.put(this.mainledger).then(res => {
          this.mainledger = Object.assign({}, res.data.newDoc)
          this.text = 'Dokument je snimljen' + res.data.message
          this.color = 'green'
          this.snackbar = true
          
        }).catch(error => {
          this.text = 'Error ' + error
          this.color = 'red'
          this.snackbar = true
        })         
      } catch (error) {
        this.text = 'Error ' + error
        this.color = 'red'
        this.snackbar = true
      }
    },
    onUploadPDF() {
      if (this.somefile && this.somefile.type === 'application/pdf') {
        const newId = this.getRndInteger(100000, 900000)
        let fd = new FormData()
        fd.append('companyId', this.$store.state.companyid)
        fd.append('newId', newId)
        fd.append('originalName', this.somefile.name)
        fd.append('typeDoc', 'BI')
        fd.append('myFile', this.somefile, this.somefile.name)
        Api().post('bookin/invoice', fd).then(response => {
            this.data = response.data
             if (this.data) {
                this.mainledger.MLFree2 = this.data.originalname ? this.data.originalname : ''
                this.mainledger.MLFree3 = this.data.filename ? this.data.filename : ''
                this.mainledger.MLFree4 = this.data.destination ? this.data.destination : ''
                this.mainledger.MLFree5 = this.data.path ? this.data.path : ''
                this.havePDF = true
                this.updateMl()
            }
        }).catch(error => {
            this.text = 'Error ' + error
            this.color = 'red'
            this.snackbar = true
            if (error.response.status === 422) {
                this.errors = error.response.data.errors || {};
            }
        });
      } else {

      }
    },
    calculateVATAmount () {
      this.mainledger.AmountVAT = ((parseNum(this.mainledger.VAT1Amount,2) + parseNum(this.mainledger.VAT2Amount,2) + parseNum(this.mainledger.VAT3Amount,2)))
      this.mainledger.AmountNetto = ((parseNum(this.mainledger.InvoiceAmount,2) - parseNum(this.mainledger.AmountVAT,2) - parseNum(this.mainledger.VAT4Base,2)))
    },
    async findByVATID(part) {
      if (part.partnerVATID) {
        const query = {}
        query.CompanyId = this.$store.state.companyid
        query.partnerVATID = part.partnerVATID

        const {data} = await PartnerService.check(query)
        console.log('partner by vatid data: ', data);
        const id = data && data.partner && data.partner.id ? data.partner.id : null
        if (id) {

          return true
        }
        if (!id) {

          return false
        }
      }
    },
    async findPartner () {
      console.log('4 FIND partner this.mainledger.partnerVATID: ', this.mainledger.partnerVATID);
      if (this.mainledger && this.mainledger.partnerVATID) {
        
        const locPartner = (await PartnerService.show(this.mainledger.partnerVATID)).data.partner
        console.log('5 --> locPartner: ', locPartner);
        this.mainledger.partnerId = locPartner.id
        this.mainledger.partnerName = locPartner.partnerName
        this.mainledger.partnerNameShort = locPartner.partnerNameShort
        this.mainledger.partnerNameDatabase = locPartner.partnerNameDatabase
        this.mainledger.partnerBuildingNameNumber = locPartner.partnerBuildingNameNumber
        this.mainledger.partnerStreet = locPartner.partnerStreet
        this.mainledger.partnerCity = locPartner.partnerCity
        this.mainledger.partnerPostcode = locPartner.partnerPostcode
        this.mainledger.partnerCountyRegion = locPartner.partnerCountyRegion
        this.mainledger.partnerState = locPartner.partnerState
        this.mainledger.partnerVATID = locPartner.partnerVATID
        this.mainledger.partneremail = locPartner.partneremail
        this.mainledger.partnerPhones = locPartner.partnerPhones
        this.mainledger.partnerBankName = locPartner.partnerBankName
        this.mainledger.partnerBankAddress = locPartner.partnerBankAddress
        this.mainledger.partnerBankIBAN = locPartner.partnerBankIBAN
        this.mainledger.partnerBankSWIFT = locPartner.partnerBankSWIFT
      }
    },
    async addeditPartner (part) {
        console.log('part.partnerVATID: ', part.partnerVATID);
        part.partnerVATID = part && part.partnerVATID && typeof part.partnerVATID === 'string' ? part.partnerVATID.trim() : ( part.partnerVATID && typeof part.partnerVATID !== 'string' ? part.partnerVATID.toString().trim(): null)
        part.partnerName = part.partnerName ? part.partnerName.trim() : null
        if (!part.partnerName || part.partnerName.length === 0) {
          this.text = 'Partner nema ime! Partner name is not defined!'
          this.color = 'red'
          this.snackbar = true
          return
        }
        if (!part.partnerVATID || part.partnerVATID.trim().length === 0) {
          this.text = 'Partner nema OIB! Partner VAT ID is not defined!'
          this.color = 'red'
          this.snackbar = true
          return
        }
        // if (!this.mainledger.partneremail || this.mainledger.partneremail.trim().length === 0) {
        //   this.text = 'Partner nema email! Partner email is not defined!'
        //   this.color = 'red'
        //   this.snackbar = true
        //   return
        // }
        const addeditPartner = {...defNewpartner()}

        addeditPartner.CompanyId = this.$store.state?.companyid ?? 0
        addeditPartner.CompanyNameDatabase = this.$store.state?.companyName ?? ''
        addeditPartner.BusinessYear = this.$store.state?.businessYear ?? new Date().getFullYear()
        addeditPartner.UserId = this.$store.state?.UserId ?? 1
        addeditPartner.email = this.$store.state?.email ?? 'test@cegrupa.com'
        addeditPartner.First = this.$store.state?.First ?? 'NoFirst'
        addeditPartner.Last = this.$store.state?.Last ?? 'NoLast'
        addeditPartner.partnerName = part.partnerName
        addeditPartner.partnerNameShort = part.partnerName.replace(/[\W_]/g, '')
        addeditPartner.partnerNameDatabase = part.partnerName.replace(/[\W_]/g, '')
        addeditPartner.partnerBuildingNameNumber = part?.partnerBuildingNameNumber ?? '';
        addeditPartner.partnerStreet = part?.partnerStreet ?? '';
        addeditPartner.partnerCity = part?.partnerCity ?? '';
        addeditPartner.partnerPostcode = part?.partnerPostcode ?? '';
        addeditPartner.partnerCountyRegion = part?.partnerCountyRegion ?? '';
        addeditPartner.partnerState = part?.partnerState ?? '';
        addeditPartner.partnerVATID = part?.partnerVATID ?? '';
        addeditPartner.partneremail = part?.partneremail ?? '';
        this.saving = true
        console.log('saving: new partner ', addeditPartner);

        const newPartner = await PartnerService.post(addeditPartner)
        this.partId = newPartner.data.partner.id ? newPartner.data.partner.id : null
        this.text = this.lang.Partneradded
        this.color = 'green'
        this.snackbar = true
        this.timeout = 2000
        await newUpdates(2)
        await testLastUpdate()
        if (this.$store.state.partnerStore) {
          this.partners = this.$store.state.partnerStore
        }
           
        this.saving = false
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    localDate(dateToFormat) {
       return dateFormat(dateToFormat)
    },
    parseDate (date) {
      if (!date) {
        return null
      }
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    async loadEinvoices() {
        try {
          this.items.length = 0
          this.total = 0
          const diffDays = dayjs(this.endDate).diff(this.startDate, 'day')
          if (diffDays > 31 ){
            throw new Error("Error! Max umber of days! Greška! Predugački period!");
          }
          this.saving = true
          this.showCard1 = false
          if (this.$store.state.companyid) {
            this.mainQuery.CompanyId = this.$store.state.companyid
          }
          if (this.$store.state.businessYear) {
            this.mainQuery.businessYear = this.$store.state.businessYear
          }
          if (this.$store.state.documentSide) {
            this.mainQuery.MLType = this.$store.state.documentSide
          }

          this.bookItems.length = 0
          const {data} = await MainLedgerService.index(this.mainQuery)
          if (data && data.documents !== undefined && data.documents.length > 0) {
            this.bookItems = data.documents
          }
          const lenItems = this.bookItems && this.bookItems.length > 0 ? this.bookItems.length : 0

          const query = {
              fromDate: this.startDate ? this.startDate : null,
              toDate: this.endDate ? this.endDate : null,
              pondiKey: this.$store.state.companyActiv.eRacunProviderAPIkey ? this.$store.state.companyActiv.eRacunProviderAPIkey : ''
          }
          let res = null
          if (this.$store.state.documentSide === 1) {
            res = await PondiService.getulazni(query)
          }
          if (this.$store.state.documentSide === 2) {
            res = await PondiService.getizlazni(query)
            console.log('query: ', query);
            console.log('res: ', res);
          }
          
          
          if (res && res.data) {
            res.data.map(itm => {
              const newItm = {...itm}
              newItm.inBooks = false
              newItm.BookID = null
              newItm.supplierPartyNameShort = itm.supplierPartyName ? itm.supplierPartyName.substring(0, 25) : ''
              this.total += itm.amount

              if (this.bookItems && this.bookItems.length > 0) {
                  let haveInBooks = {}

                  for(let i = 0; i < lenItems; i++) {
                    if (this.$store.state.documentSide === 1 && this.bookItems[i].InvoiceNumber === itm.documentId && this.bookItems[i].partnerVATID === itm.supplierPartyVATId) {
                      haveInBooks = this.bookItems[i]
                      break
                    }
                    if (this.$store.state.documentSide === 2 && this.bookItems[i].InvoiceNumber === itm.documentId && this.bookItems[i].partnerVATID === itm.customerPartyVATId) {
                      haveInBooks = this.bookItems[i]
                      break
                    }
                 }
           
                if (Object.keys(haveInBooks).length > 0) {
                  
                  newItm.inBooks = true
                  newItm.BookID = haveInBooks.BookID
                  newItm.BookName = haveInBooks.BookName
                  newItm.BookingDate = haveInBooks.BookingDate
                  newItm.email = haveInBooks.email
                 
                }
              }
              this.items.push(newItm)
            })
            this.total = round(this.total, 2)
            this.showCard1 = true
          }
          this.saving = false
        } catch (error) {
            this.error = error
            this.saving = false
            alert(error)
        }
    }


  },
  watch: {
    'selectedMonth' () {
     if  (this.selectedMonth) {
       let y = this.$store.state.businessYear
       let m = this.selectedMonth - 1;
       let firstDay = new Date(y, m, 1);
       let lastDay = new Date(y, m + 1, 0);

      this.startDate = dayjs(firstDay).format('YYYY-MM-DD')
      this.endDate = dayjs(lastDay).format('YYYY-MM-DD')

     }
     if (!this.selectedMonth) {
      this.startDate = dayjs([this.mainledgerAna.BusinessYear]).startOf('month').format('YYYY-MM-DD')
      this.endDate = dayjs([this.mainledgerAna.BusinessYear]).endOf('month').format('YYYY-MM-DD')
     }
   },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

</style>
